import Axios from 'axios'
import React,{useEffect,useCallback,useState } from 'react';
import { Pagination } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table } from "react-bootstrap";
import { dataList } from "../Pages/DataList";
import { MultiSelect } from "react-multi-select-component";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import BadgeIcon from '@mui/icons-material/Badge';
import Moment from 'moment';
import './List.css'
const Swal = require('sweetalert2');
var CryptoJS = require("crypto-js/core");
CryptoJS.AES = require("crypto-js/aes");
var secret = "Ec";

export const ListCustomer = () => {
  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          Swal.fire({
            title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.isConfirmed) { 
              window.location.href = '/ec-crm/Login'
            }
          })
        }
    });
})
  //โครงการ
  const [ProjectList, setProjectList] = useState([]);
  const [TypeCusList, setTypeCusList] = useState([]);
  const [GradeList, setGradeList] = useState([]);
  const [CustomerName, setName] = useState(""); 
  const [CustomerList, setCustomerList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); 
  const pageData = dataList(CustomerList, 10, currentPage);
  const pageList = pageData.pageList.filter((x) => x.length !== 0);
  const items = pageData.items;
  // Items Number Button
  const pageClick = (page) => {
    setCurrentPage(page);
  };
  // Previous Button
  const prevClick = () => {
    setCurrentPage(currentPage - 1);
  };
  // Next Button
  const nextClick = () => {
    setCurrentPage(currentPage + 1);
  };
  //ประภทลูกค้า
  const [EmployeeType, setEmployeeType] = useState("");
  const [EmpId, setEmpId] = useState("");
  useEffect(() => {
    const EmployeeType = JSON.parse(localStorage.getItem('EmployeeType'));
    if (EmployeeType) {
      setEmployeeType(EmployeeType);
     }
  },[setEmployeeType]);
  useEffect(() => {
    const EmpId = JSON.parse(localStorage.getItem('EmpId'));
    if (EmpId) {
      setEmpId(EmpId);
     }
  },[setEmpId]);
  useEffect(() => {
    Axios.get('http://27.254.66.164:5000/typecus').then((response) => {
      setTypeCusList(response.data);
    });
  },[]);
  useEffect(() => {
    Axios.get('http://27.254.66.164:5000/gradedes').then((response) => {
      setGradeList(response.data);
    });
  },[]);
  useEffect(() => {
    Axios.post('http://27.254.66.164:5000/projectserch',{
      EmployeeType:EmployeeType,
      EmpId:EmpId
    }).then((response) => {
      setProjectList(response.data);
    });
  }, [EmployeeType,EmpId]);
  const CusTypes = TypeCusList.map((item,i) =>( { key: i,value: item.TypeCusId, label: item.TypeCusDes } ));
  const ProjectAll = ProjectList.map((item,i)=>( { key: i,value: item.ProjectId, label: item.ProjectShortName+" : "+item.ProjectName} ));
  const Grades = GradeList.map((item,i) =>( { key: i,value: item.GradeId , label: item.GradeDes } ));
  const [ProjectId, setProjectId] = useState([]);
  const [CusType, setCusType] = useState([]);
  const [Grade, setGrade] = useState([]);

  const resultCus = (CusType.map(e => e.value).flat().toString());
  const result = (CusTypes.map(e => e.value).flat().toString());
  const resultp = (ProjectAll.map(e => e.value).flat().toString());
  const resultPro = (ProjectId.map(e => e.value).flat().toString());
  const resultG = (Grades.map(e => e.value).flat().toString());
  const resultGrade = (Grade.map(e => e.value).flat().toString());
  const serch = useCallback(() => {
          Axios.post('http://27.254.66.164:5000/ListCus', {
            resultPro: resultPro,
            resultCus:resultCus,
            resultG:resultG,
            resultGrade:resultGrade,
            result:result,
            resultp:resultp
          
          }).then((response) => {
            setCustomerList(response.data);
          });
          }, [resultPro,resultCus,result,resultp,resultG,resultGrade]);
    useEffect(() => {
      serch();
    },[serch]);
    const  handleOnchangePro  =  val  => {
      setProjectId(val)
    }
    const  handleOnchangeCus  =  val  => {
      setCusType(val)
    }
    const  handleOnchangeGrade  =  val  => {
      setGrade(val)
    }
  return (
    <div className="container">
        <div className="row">
          <form align="center">  
            <br></br>  
            <div className="row justify-content-md-center">
                <div className="col col-lg-5" >
                    <input type="text" className='form-control' placeholder="ชื่อ-นามสกุล"  value={CustomerName} onChange={event => setName(event.target.value)}/>
                </div>   
                <div className="col col-lg-5" >
                      <MultiSelect   
                            className="msl-vars"   
                            key={ProjectList.map((item,i) =>( { key: i} ))}
                            value={ProjectId}  
                            onChange={handleOnchangePro} 
                            options={ProjectAll}
                            disableSearch={true}
                            overrideStrings={{
                              selectSomeItems: "กรุณาเลือกโครงการ",
                              allItemsAreSelected: "ทุกโครงการ",
                              selectAll: "ทุกโครงการ",
                              search: "ค้นหา",
                              noOptions: "ไม่มีโครงการ"
                            }}
                            labelledBy="Select"
                        />
                </div>      
            </div>  
            <br></br>  
            <div className="row justify-content-md-center">  
                <div className="col col-lg-5" >
                      <MultiSelect   
                            className="msl-vars"   
                            key={TypeCusList.map((item,i) =>( { key: i} ))}
                            value={CusType}  
                            onChange={handleOnchangeCus} 
                            options={CusTypes}
                            overrideStrings={{
                              selectSomeItems: "กรุณาเลือกประเภทลูกค้า",
                              allItemsAreSelected: "ทุกประเภท",
                              selectAll: "ทุกประเภท",
                              search: "ค้นหาประเภทลูกค้า",
                              noOptions: "ไม่มีประเภทลูกค้า"
                            }}
                            labelledBy="Select"
                        />
                </div> 
                <div className="col col-lg-5" >
                      <MultiSelect   
                            className="msl-vars"   
                            key={GradeList.map((item,i) =>( { key: i} ))}
                            value={Grade}  
                            onChange={handleOnchangeGrade} 
                            options={Grades}
                            overrideStrings={{
                              selectSomeItems: "กรุณาเลือกความสนใจของลูกค้า",
                              allItemsAreSelected: "ทุกรายการความสนใจของลูกค้า",
                              selectAll: "ทุกรายการความสนใจของลูกค้า",
                              search: "ค้นหาความสนใจลูกค้า",
                              noOptions: "ไม่มีความสนใจลูกค้า"
                            }}
                            labelledBy="Select"
                        />
                </div> 
            </div>
            <br></br>  
          </form>
          <Table striped bordered hover variant="warning" responsive="md" size="lg" className="table-sort">
            <thead>
              <tr>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >ชื่อลูกค้า</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} width="10%">วันที่เข้าระบบ</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} width="10%">เคลื่อนไหวล่าสุด</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >ประเภทผู้สนใจ/โครงการ</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >สถานะฟอร์มลูกค้า</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >รายละเอียด</th>
              </tr>
            </thead>
            <tbody>
              {pageList.filter((post, index) => {
                  if (CustomerName === '') {
                      return CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1);
                  }else{
                      return CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1).toString().toLowerCase().includes(CustomerName);
                  }
                }).map((entry, index) => (
                <tr key={index}>
                  <td >
                        <div className="input-group">
                            <span><BadgeIcon />{CryptoJS.AES.decrypt(entry.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(entry.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1)}</span>
                        </div>
                        <div className="input-group">
                            <span><LocalPhoneIcon />{CryptoJS.AES.decrypt(entry.Phone,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(entry.Phone,secret).toString(CryptoJS.enc.Utf8).length - 1)}</span>
                        </div>
                        <div className="input-group">
                            <span><img src = {require('./../img/line.png')} width="25" height="25"  alt="logo" />{CryptoJS.AES.decrypt(entry.LineID,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(entry.LineID,secret).toString(CryptoJS.enc.Utf8).length - 1)}</span>
                        </div>
                  </td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }} >{Moment(entry.MinDay).format('DD-MM-YYYY')}</td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }} >{Moment(entry.MaxDay).format('DD-MM-YYYY')}</td>
                  <td style={{ "verticalAlign": "middle" }}> 
                        <div className="input-group">
                            {entry.TypeCus}
                        </div>
                  </td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }} >
                  <div>
                     {entry.StatusQues == 1  ?
                          <span><img src = {require('./../img/True.jpg')} width="50" height="50"  alt="logo" /></span>
                      
                     :
                          <span><img src = {require('./../img/False.jpg')} width="50" height="50"  alt="logo" /></span>
                     }
                  </div>
                  </td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }} >
                    <div>
                     {entry.StatusQues == 1  ?
                      <button type="button" className="btn btn-danger"  aria-haspopup="true" aria-expanded="false" onClick={() => {window.location.href='/ec-crm/Edit?CustomerId='+ entry.CrmCustomerId}}>
                        <span className="glyphicon glyphicon-edit"></span> แก้ไขข้อมูลลูกค้า 
                      </button>
                     :
                      <button type="button" className="btn btn-success"  aria-haspopup="true" aria-expanded="false" onClick={() => {window.location.href='/ec-crm/Form?CustomerId='+ entry.CrmCustomerId}}>
                          <span className="glyphicon glyphicon-star"></span> ทำฟอร์มลูกค้า 
                      </button>
                     }
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        <Pagination>
          <Pagination.Prev onClick={prevClick} />
          {items.map((item, index) => {
            return (
              <Pagination.Item
                key={index}
                active={item === currentPage}
                onClick={() => pageClick(item)}>
                {item}
              </Pagination.Item>
            );
          })}
          <Pagination.Next onClick={nextClick} />
        </Pagination>
        </div>
      </div>

  );
}
